<template>
	<focus-lock :return-focus="true">
		<div
			class="modal"
			:class="{ 'modal--indent' : indent }"
			ref="modal"
		>
			<button
				type="button"
				class="modal__close btn--no-style"
				@click="closeModal"
			>
				<svg svg-inline="" focusable="false" role="presentation" width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M15.382 12.583l9.176 9.175-2.85 2.851-9.176-9.175-9.182 9.18-2.862-2.861 9.181-9.181L.494 3.396l2.85-2.85L12.52 9.72 21.701.54l2.863 2.862z" fill="#717171" fill-rule="evenodd"/></svg>
				<div>Close</div>
			</button>

			<slot></slot>

			<button
				v-if="hasScrollToTop"
				@click="scrollToTop"
				type="button"
				class="btn--no-style btn-to-top btn-to-top--center"
			>
				<div class="btn-to-top__icon">
					<svg svg-inline="" focusable="false" role="presentation" width="10" height="7" viewBox="0 0 10 7" xmlns="http://www.w3.org/2000/svg"><g fill="#FFF"><path d="M5.463 1.13c.393.392.471.836.196 1.11L4.287 3.615l-.916.915L2 5.902c-.275.274-.72.196-1.112-.196-.392-.393-.47-.837-.196-1.112l1.373-1.373.915-.915L4.352.933c.275-.274.72-.196 1.111.196z"/><path d="M4.524 1.13c-.393.392-.471.836-.196 1.11L5.7 3.615l.916.915 1.373 1.373c.274.274.719.196 1.11-.196.393-.393.471-.837.197-1.112L7.923 3.221l-.915-.915L5.635.933C5.36.66 4.915.737 4.524 1.13z"/></g></svg>
				</div>
				<div class="btn-to-top__text">Top</div>
			</button>

			<template
				v-if="$slots.modalFooter"
			>
				<slot name="modalFooter"></slot>
			</template>

		</div>
	</focus-lock>
</template>

<script>
// Mixins
import { modal } from '@/mixins/modal.js';

// Components
import FocusLock from 'vue-focus-lock';

// Styles
import '@/sass/components/_modal.scss';

export default {
	mixins: [modal],
	props: ['hasScrollToTop', 'indent'],
	components: {
		FocusLock
	},
	watch: {
		$route() {
			this.$parent.modalOpen = false;
			this.removeModalBodyClass();
		}
	},
	methods: {
		closeModal() {
			this.$parent.modalOpen = false;
			this.removeModalBodyClass();
		},
		scrollToTop() {
			this.$refs.modal.scrollTo(0, 0);
		}
	},
	mounted() {
		scroll(0, 0);

		this.addModalBodyClass();
	},
	beforeDestroy() {
		this.removeModalBodyClass();
	}
};
</script>
